import { Row, Col, Card, Icon, Form, Input, Tooltip } from 'antd';
import { ssFormUtils, ssFormValidationUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import { email } from './formConfig';

const
config = email,
{ key } = config,
{ generateFormItem, generateInputComponent } = ssFormUtils,
{ validateForm, validateSubForm } = ssFormValidationUtils,
EMAIL_FIELD = 'emailAddress',
VERIFY_EMAIL = 'verifyEmailAddress',
VERIFY_MESSAGE = 'Email addresses must match';

export default class IdAndEmail extends React.Component {
    state = { isValid: false }
    constructor(props) { super(props); }

    componentDidUpdate(prevProps) {
        const
        { services, registrationForm } = this.props,
        form = registrationForm[key],
        prevForm = prevProps.registrationForm[key],
        { storeForm } = services;

        if(!ssCommonUtils.simpleObjectCompare(prevForm, form)) {
            const formState = validateForm(form, config, true);
            storeForm(key, formState);
            this.setState({ isValid: this.verifyEmail(this.props) && validateSubForm(formState) });
        }
    }

    verifyEmail(nextProps) {
        const
        { registrationForm } = nextProps,
        form = registrationForm[key];

        if(form[VERIFY_EMAIL] && form[EMAIL_FIELD])
            if (form[VERIFY_EMAIL] === form[EMAIL_FIELD]) {
                this.setEmailVerificationError(false);
                return true;
            }

        this.setEmailVerificationError(true);
        return false;
    }

    setEmailVerificationError(inError) {
        const
        { services } = this.props,
        { storeFormField } = services;
        storeFormField(key, VERIFY_EMAIL + '_help', inError ? VERIFY_MESSAGE : '');
        storeFormField(key, VERIFY_EMAIL + '_status', inError ? 'error' : 'success');
    }

    setMaxWidth = d => ({...d, style: { width: '100%' }});

    render() {
        const
        { services, registrationForm } = this.props,
        form = registrationForm[key],
        { storeForm, storeFormField } = services;

        return (
            <div>
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={16}>
                        <Card hoverable style={{ cursor: 'default' }} bodyStyle={{ padding: '10px' }}>
                            <div style={{ marginBottom: '20px' }}>
                                <Icon type='info-circle-o' style={{ fontWeight: 'bold', marginRight: '6px' }} />
                                {'Please create a User ID; it will be a permanent feature of your account. '}
                                {'The User ID is used when communicating and transmitting documents '}
                                {'between other agencies such as the FBI for fingerprinting purposes. '}
                                <span style={{ fontWeight: 'bold' }}>{'Your User ID is permanent and cannot be changed.'}</span>
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <Icon type='info-circle-o' style={{ fontWeight: 'bold', marginRight: '6px' }} />
                                {'Please provide a valid personal email address. '}
                                {'TSA will email your temporary password and instructions to this email address. '}
                                {'Make sure the email address you provide is valid and you have access to it. '}
                                {'Your email is the primary way TSA will communicate with you.'}
                            </div>
                        </Card>
                    </Col>
                </Row>
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={16}>
                        <Form>
                            <Row type='flex' justify='space-around' align='middle' gutter={10}>
                                <Col span={8}>
                                    <Form.Item {...generateFormItem('userId', config, form)}>
                                        <Input {...this.setMaxWidth(generateInputComponent('userId', config, true, form, storeFormField, storeForm))}/>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item {...generateFormItem('emailAddress', config, form)}>
                                        <Input {...this.setMaxWidth(generateInputComponent('emailAddress', config, true, form, storeFormField, storeForm))}/>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item {...generateFormItem('verifyEmailAddress',  config, form)}>
                                        <Input {...this.setMaxWidth(generateInputComponent('verifyEmailAddress', config, true, form, storeFormField, storeForm))}/>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </div>
        )
    }
}
